import React, { useContext, useState } from "react";
import { ForgotPasswordSchema } from "../../../components/Helpers";
import { Formik, Form, Field } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { forgotPassword as authapisForgotPassword } from "../../../Services/authapis";
import datacloud from "../../../Assets/unisoft.jpg";
import { LoginContext } from "../../../Context/Auth";
import TextInput from "../../../components/TextInput";

function ForgotPasswordForm() {
  const navigate = useNavigate();
  const [emailSent, setEmailSent] = useState(false);
  const [loading, setLoading] = useState(false);

  // Simulated async forgot password handler (replace with real API)
  const forgotPassword = async (values) => {
    setLoading(true);
    try {
      // Simulate API call
      await authapisForgotPassword(values.email);
      setEmailSent(true);
      toast.success("Email sent successfully!");
    } catch (err) {
      let errorMessage =
        err?.response?.data?.message ||
        err?.response?.data ||
        "Invalid email, please try again";

      if (
        typeof errorMessage === "string" &&
        errorMessage.startsWith("No user found with email:")
      ) {
        errorMessage = "No user was found with the provided email address.";
      }

      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center w-[80vw] sm:w-[60vw] md:w-[24vw] p-3 md:px-5 bg-white rounded-2xl h-[50vh] sm:h-[55vh]">
      {!emailSent ? (
        <Formik
          initialValues={{
            email: "",
          }}
          validationSchema={ForgotPasswordSchema}
          onSubmit={forgotPassword}
        >
          {({ errors, touched, values, handleChange }) => (
            <Form className="shadow-none w-full h-full mt-5 sm:mt-10">
              <div className="text-center mb-6 sm:mb-8">
                <span className="flex items-center justify-center p-4">
                  <img src={datacloud} alt="Logo" className="h-16 sm:h-20 w-auto object-contain" />
                </span>
                <h1 className="text-2xl sm:text-3xl font-bold text-primary mb-2">
                  Forgot Password
                </h1>
                <p className="text-md sm:text-lg flex items-center justify-center mb-6 sm:mb-10">
                  Enter your registered email to receive reset instructions
                </p>
              </div>
              <div className="mb-4">
                <TextInput
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={values.email}
                  handleChange={handleChange}
                  legend={true}
                  required={true}
                  classes="w-full"
                />
                {errors.email && touched.email ? (
                  <p className="text-red-400">{errors.email}</p>
                ) : null}
              </div>
              <div className="mb-6 flex items-center justify-end">
                <Link
                  className="text-primary hover:underline"
                  to="/login"
                >
                  Back to Login
                </Link>
              </div>
              <button
                type="submit"
                className="w-full text-white font-medium text-lg bg-[#201F1E] hover:bg-[#201F1E] p-2 rounded"
                disabled={loading}
              >
                {loading ? "Sending..." : "Submit"}
              </button>
            </Form>
          )}
        </Formik>
      ) : (
        <div className="text-center w-full">
          <h1 className="text-2xl sm:text-3xl font-bold text-primary mb-2">
            Email Sent
          </h1>
          <p className="mb-4 text-md sm:text-lg">
            Email has been sent to your registered email address.
          </p>
          <Link
            className="text-primary hover:underline"
            to="/login"
          >
            Back to Login
          </Link>
        </div>
      )}
    </div>
  );
}

export default ForgotPasswordForm;
